import Backbone from "backbone";
import Raven from "raven-js";

// Use dispatch to run actions.
// Dispatch(actionType, args...)

// Use Dispatch.on to add an action type handler:
// Dispatch.on(actionType, (args...) => { /* ... */ });
function Dispatch(actionType, ...args) {
  if (Dispatch.debug) {
    // eslint-disable-next-line no-console
    console.log("Dispatch:", actionType, args);
  }
  Raven.captureBreadcrumb({
    category: "Dispatch",
    level: "info",
    message: actionType,
  });
  Dispatch.trigger(actionType, ...args);
}

_.extend(Dispatch, Backbone.Events);

// It's useful to have Dispatch be a global so that you can set Dispatch.debug
// to true and manually Dispatch stuff from the browser console.
global.Dispatch = Dispatch;

export default Dispatch;



// WEBPACK FOOTER //
// ./src/flux_like/dispatch.js